import DebugModal from './DebugModal'
import StepDebugView, { StepDebugData } from './views/StepDebugView'

export default function StepDebugModal(props: StepDebugData) {
  return (
    <DebugModal debugKey="step" label="Step">
      <StepDebugView {...props} />
    </DebugModal>
  )
}
